import { CONSTANTS_STRINGS, RoutesPath } from "src/constants";

import { useEffect } from "react";
import { useNavigate } from "react-router";
import { LayoutCard, MainLayout } from "src/components/layout";
import { BackButton, NoticeCard } from "src/components/shared";
import {
  CaptionMLow,
  HeadlineSize8Medium,
} from "src/components/ui/typographic";
import useTokenNavigate from "src/hooks/useTokenNavigate";
import { useCheckoutDataContext } from "src/providers/SharedDataProvider";
import { DirectDebtPaymentMethodChangeFormData } from "src/schemas/DirectDebtFormSchema";
import useFormStore from "src/store/formStore";
import { CheckoutHelper } from "src/utils";
import AuthorizePaymentButton from "./AuthorizePaymentButton";
import DetailCard from "./DetailCard";

const DirectDebitAuthorization: React.FC = () => {
  const navigate = useNavigate();
  const { handleTokenNavigate } = useTokenNavigate();
  const data = useCheckoutDataContext();
  const { accountData, updateAccountData } = useFormStore();
  const paymentAmount = data?.checkoutPreferences.totalAmount;
  const isPaymentMethodChange = !CheckoutHelper.isInstallmentRequired(data);

  const handleUpdateAccountData = (
    updatedData: DirectDebtPaymentMethodChangeFormData,
  ) => {
    updateAccountData(updatedData);
  };

  useEffect(() => {
    if (!accountData) {
      void navigate(handleTokenNavigate(RoutesPath.DIRECT_DEBIT));
    }
  }, [accountData, navigate, handleTokenNavigate]);

  return (
    <MainLayout>
      <HeadlineSize8Medium className="text-left">
        {CONSTANTS_STRINGS.DIRECT_DEBIT_PAGE_TITLE}
      </HeadlineSize8Medium>
      <LayoutCard>
        <p className="items-start">
          {CONSTANTS_STRINGS.DIRECT_DEBIT_AUTHORIZATION_SUBTITLE}
        </p>
        <DetailCard
          amount={paymentAmount}
          accountData={accountData}
          onUpdateAccountData={handleUpdateAccountData}
          isPaymentMethodChange={isPaymentMethodChange}
        />
        <NoticeCard>
          <CaptionMLow className="flex flex-col gap-2">
            <span>
              {
                CONSTANTS_STRINGS.DIRECT_DEBIT_AUTHORIZATION_INFO_CARD_DESCRIPTION
              }
            </span>
            <span>
              <span className="font-semibold">
                {
                  CONSTANTS_STRINGS.DIRECT_DEBIT_AUTHORIZATION_INFO_CARD_IMPORTANT_LABEL
                }
              </span>{" "}
              {
                CONSTANTS_STRINGS.DIRECT_DEBIT_AUTHORIZATION_INFO_CARD_IMPORTANT_MESSAGE
              }
            </span>
          </CaptionMLow>
        </NoticeCard>
        <section className="flex flex-row items-center justify-between gap-4">
          <BackButton />
          <AuthorizePaymentButton accountData={accountData} />
        </section>
      </LayoutCard>
    </MainLayout>
  );
};

export default DirectDebitAuthorization;
